import { render, staticRenderFns } from "./bottomFloat.vue?vue&type=template&id=1c87ef2e&scoped=true&"
import script from "./bottomFloat.vue?vue&type=script&lang=js&"
export * from "./bottomFloat.vue?vue&type=script&lang=js&"
import style0 from "./bottomFloat.vue?vue&type=style&index=0&id=1c87ef2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c87ef2e",
  null
  
)

export default component.exports